import React, { Component } from 'react';
import ProductDataSelector from './components/ProductDataSelector';

import './ProductDataStep.css';

class ProductDataStep extends Component {
    constructor(props) {
        super(props);

        // See if we have any data for sizes
        let sizes = {};
        const currentSizeData = props.collectedData.selectSizesStep;

        if (typeof currentSizeData === 'undefined') {
            // We haven't collected any data
            // pass
        } else {
            const emptySizesObject = (Object.keys(currentSizeData).length === 0 && currentSizeData.constructor === Object);
            sizes = emptySizesObject ? {}: currentSizeData;
        }

        // See if we have any data for prices
        let prices = {};
        const currentPriceData = props.collectedData.selectPricesStep;
        if (typeof currentPriceData === 'undefined') {
            // Pass
        } else {
            const emptyPricesObject = (Object.keys(currentPriceData).length === 0 && currentPriceData.constructor === Object);
            prices = emptyPricesObject ? {} : currentPriceData;
        }

        //TODO: Add persistence for sizes
        this.state = {
            selectedSizes: sizes,
            selectedPrices: prices,
            errorMessage: '',
            categories: props.collectedData.selectCategoriesStep
        };

        this.processDataForNextStep = this.processDataForNextStep.bind(this);
        this.getSelectedClass = this.getSelectedClass.bind(this);
        this.addSizeToObject = this.addSizeToObject.bind(this);
        this.addPriceToObject = this.addPriceToObject.bind(this);
        this.renderSelectedCategories = this.renderSelectedCategories.bind(this);
        this.renderSizeAndPriceSelectors = this.renderSizeAndPriceSelectors.bind(this);
    }

    processDataForNextStep() {
        //TODO: Refactor this, it shouldn't depend on key creation checking to validate itself it's way too complicated for something that's really simple.
        // Don't allow blank submissions overall
        let noSizesAdded = Object.keys(this.state.selectedSizes).length !== this.state.categories.length;

        if (noSizesAdded) {
            this.setState({ errorMessage: 'Please select at least one size per category.'});
            return;
        }

        // Don't allow blank submissions once they toggle the key to initialization
        let emptySizeValues = false;
        for (let key in this.state.selectedSizes) {
            if (this.state.selectedSizes.hasOwnProperty(key)) {
                //For this key, check if the associated list is empty
                if (this.state.selectedSizes[key].length === 0) {
                    emptySizeValues = true;
                    break;
                }
            }
        }

        if (emptySizeValues) {
            this.setState({ errorMessage: 'Please select at least one size per category.'});
            return;
        }

        // Pass the data to the parent component state
        const data = {
            selectSizesStep: this.state.selectedSizes,
            selectPricesStep: this.state.selectedPrices
        };

        this.props.nextStep(data);
    }

    addPriceToObject(label, internalName, price) {
        let currentlySelectedPrices = this.state.selectedPrices;
        currentlySelectedPrices[internalName] = { price: price, label: label};

        this.setState({
            selectedPrices: currentlySelectedPrices
        });
    }

    addSizeToObject(category, size) {
        let currentlySelectedSizes = this.state.selectedSizes;

        if (Object.keys(currentlySelectedSizes).indexOf(category) === -1) {
            // Add a list to that
            currentlySelectedSizes[category] = [];
            currentlySelectedSizes[category].push(size);
        } else {
            // Key exists, check if the size is also there
            let currentSizes = currentlySelectedSizes[category];
            let idx = currentSizes.indexOf(size);
            if (idx  === -1) {
                //add it
                currentlySelectedSizes[category].push(size);
            } else {
                //remove it
                currentlySelectedSizes[category].splice(idx, 1);
            }
        }

        this.setState({
            selectedSizes: currentlySelectedSizes
        });
    }

    renderSelectedCategories() {
        return this.state.categories.map((category, idx) => (
            <kbd className="selected-category-kdb" key={idx}>
                {category.label}
            </kbd>
        ));
    }

    getSelectedClass(category, size) {
        if (this.state.selectedSizes[category] === undefined) {
            return '';
        } else if (this.state.selectedSizes[category].indexOf(size) !== -1) {
            return ' selected-size';
        } else {
            return '';
        }
    }

    renderSizeAndPriceSelectors() {
        return this.state.categories.map(category => (
            <ProductDataSelector
                category={category}
                startPrice={this.state.selectedPrices[category.internalName]}
                setPrice={this.addPriceToObject}
                addSizeToObject={this.addSizeToObject}
                getSelectedClass={this.getSelectedClass}
                key={category.internalName}
            />
        ));
    }

    render() {
        return (
            <div className="select-sizes-component">
                <h2 className="select-sizes-header">So, thus far we've got you down for the following:</h2>
                <div className="selected-category-kdb-container">
                    {this.renderSelectedCategories()}
                </div>

                <p className="size-sub-header">For each product (where applicable) select the sizes and prices.</p>
                <p className={"sizes-error " + (this.state.errorMessage.length > 0 ? '' : ' hidden-error')}>
                    {this.state.errorMessage}
                </p>

                <div className="size-selectors-container row">
                    {this.renderSizeAndPriceSelectors()}
                </div>

                <div className="size-step-buttons">
                    <button id="prevStepButton" onClick={this.props.previousStep} className="circle-step-button">
                        <i className="ion ion-android-arrow-back" />
                    </button>

                    <button id="nextStepButton" onClick={this.processDataForNextStep} className="circle-step-button">
                        <i className="ion ion-android-arrow-forward" />
                    </button>
                </div>
            </div>
        );
    }
};

export default ProductDataStep;


// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Onboard/StepComponents/ProductDataStep/ProductDataStep.js